import { render, staticRenderFns } from "./TenantInvoice.vue?vue&type=template&id=4bc482d4&scoped=true"
import script from "./TenantInvoice.vue?vue&type=script&lang=js"
export * from "./TenantInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc482d4",
  null
  
)

export default component.exports